module.exports = __webpack_public_path__ + "static/media/payments.90a4615e.svg";